export default __webpack_public_path__ + "static/media/ne.7f89cafb.svg";